module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_c/aoj_c-2-fcd0e8200d194e0f43f8124cc5ba98b5.jpg";